import gql from 'graphql-tag'

export const ONBOARDING_QUERY = gql`
query userSubscriptions($productType: String, $stage: String, $coachId: ID, $connectOwnerId: ID, $supportOwnerId: ID){
  userSubscriptions(product_Type: $productType, stage: $stage, coachId: $coachId, connectOwnerId: $connectOwnerId, supportOwnerId: $supportOwnerId, active: true){
    edges {
      node {
        id
        startDate
        endDate
        stage
        active
        onboardingCompleted
        submittedMedicalForm
        programStartDate
        messageSentByUser
        messageSentByCoach
        payfastCancelled
        billingOrder {
          id
          package {
            id
            title
          }
        }
        product {
          id 
          name
        }
        userEmailComms {
          id
          createdAt
          event
          sgTemplateName
        }
        onboardingProgram {
          id
          programStartDate
          program {
            id
            name
          }
          nextProgram {
            id
            name
          }
        }

        initialAssessment {
          id
          requiredDate
          assessmentDate
          weight
          abdomen
          chest
          hip
          quad
          imgFront
          imgBack
          imgSide
          calendlyUuid
        }
        coach {
          id
          firstName
          lastName
        }
        connectOwner {
          id
          firstName
          lastName
        }
        supportOwner {
          id
          firstName
          lastName
        }
        user {
          id
          firstName
          lastName
          lastLogin
          email
          subscriptionblockSet {
            id
            startDate
            endDate
            block {
              id
              title
              type
            }
          }
          subscriptionnutritionblockSet {
            edges {
              node {
                id
                startDate
                nutritionBlock {
                  id
                  title
                }
                nutritionBlock {
                  id
                  title
                }
              }
            }
          }
          userProfile{
            id
            phone
            coachingChat {
              id
            }
            nutritionPlan {
              id
              name
            }
            coachingNutritionPlan {
              id
              servingSize
              dietaryRestriction
              pdf
            }
          }
        }
      }
    }
  } 
}
`;

export const COACHING_ONBOARDING_SUMMARY_QUERY = gql`
query coachOnboardingSummary {
  coachOnboardingSummary {
    coach {
      id
      firstName
      lastName
    }
    min
    max
    average
    total
  }
}
`;

export const CLUB_ONBOARDING_QUERY = gql`
query userSubscriptions($productType: String, $stage: String, $coachId: ID, $connectOwnerId: ID, $supportOwnerId: ID){
  userSubscriptions(product_Type: $productType, stage: $stage, coachId: $coachId, connectOwnerId: $connectOwnerId, supportOwnerId: $supportOwnerId, active: true){
    edges {
      node {
        id
        startDate
        endDate
        stage
        active
        onboardingCompleted
        userEmailComms {
          id
          createdAt
          event
          sgTemplateName
        }
        previousProduct {
          id 
          name
        }
        subscriptionProcessChecks {
          id
          user {
            id
            firstName
            lastName
          }
          type
        }
        supportOwner {
          id
          firstName
          lastName
        }
        user {
          id
          firstName
          lastName
          lastLogin
          email
          subscriptionblockSet {
            id
            startDate
            endDate
            block {
              id
              title
              type
            }
          }
          subscriptionnutritionblockSet {
            edges {
              node {
                id
                startDate
                nutritionBlock {
                  id
                  title
                }
              }
            }
          }
          useractivitySet(first:1) {
            edges {
              node {
                id
              }
            }
          }
          userProfile{
            id
            phone
          }
        }
      }
    }
  } 
}
`;

export const LIFE_ONBOARDING_QUERY = gql`
query userSubscriptions($productType: String, $stage: String, $coachId: ID, $connectOwnerId: ID, $supportOwnerId: ID){
  userSubscriptions(product_Type: $productType, stage: $stage, coachId: $coachId, connectOwnerId: $connectOwnerId, supportOwnerId: $supportOwnerId, active: true){
    edges {
      node {
        id
        startDate
        endDate
        stage
        active
        onboardingCompleted
        product {
          id
          name
        }
        userEmailComms {
          id
          createdAt
          event
          sgTemplateName
        }
        previousProduct {
          id 
          name
        }
        subscriptionProcessChecks {
          id
          user {
            id
            firstName
            lastName
          }
          type
        }
        supportOwner {
          id
          firstName
          lastName
        }
        user {
          id
          firstName
          lastName
          lastLogin
          email
          userbadgeSet {
            id 
          }
          useractivitySet(first:1) {
            edges {
              node {
                id
              }
            }
          }
          userProfile{
            id
            phone
          }
        }
      }
    }
  } 
}
`;

export const PRIORITY_ONBOARDING_QUERY = gql`
query userSubscriptions($stage: String, $coachId: ID, $connectOwnerId: ID, $supportOwnerId: ID){
  userSubscriptions(product_Type: "one-on-one", stage: $stage, coachId: $coachId, connectOwnerId: $connectOwnerId, supportOwnerId: $supportOwnerId, active: true){
    edges {
      node {
        id
        startDate
        endDate
        stage
        active
        onboardingCompleted
        programStartDate
        messageSentByCoach
        onboardingProgram {
          id
          user {
            id
            firstName
            lastName
          }
        }
        product {
          id 
          name
        }
        coach {
          id
          firstName
          lastName
        }
        connectOwner {
          id
          firstName
          lastName
        }
        supportOwner {
          id
          firstName
          lastName
        }
        user {
          id
          firstName
          lastName
          lastLogin
          email
          userEmailCommunications {
            id
            createdAt
            event
            sgTemplateName
          }
          userProfile{
            id
            phone
          }
        }
      }
    }
  } 
}
`;


export const CLIENT_WITH_ONBOARDING_QUERY = gql`
query client($userId: ID!) {
  userSubscriptions(product_Type: "one-on-one", stage: "onboarding", userId: $userId, active: true){
    edges {
      node {
        id
        startDate
        endDate
        stage
        active
        onboardingCompleted
        submittedMedicalForm
        programStartDate
        subscriptionProcessChecks{
          user {
            id
            firstName
          }
          type
        }
        coachingAssessments {
          id
          requiredDate
          assessmentDate
          weight
          abdomen
          chest
          hip
          quad
          imgFront
          imgBack
          imgSide
          calendlyUuid
        }
        coach {
          id
          firstName
          lastName
        }
        user {
          id
          firstName
          lastName
          lastLogin
          email
          userProfile{
            id
            phone
            gender
            dateOfBirth
            height
          }
        }
      }
    }
  } 
}
`

export const CLIENT_COACH_HISTORY_QUERY = gql`
query clientHistoryQuery($coachId: ID!, $orderBy: String) {
  userSubscriptions(product_Type: "one-on-one" coachId: $coachId, active: false, orderBy: $orderBy){
    edges {
      node {
        id
        startDate
        endDate
        likelyToReturnOneOnOne
        notesOnWhyLeft
        earliestIncompleteFollowUpDate
        user {
          id
          firstName
          lastName
          lastLogin
          email
          rewards: eventSet(approvalStatus: "APPROVED"){
            totalPoints
          }
          userProfile{
            id
            phone
            gender
            dateOfBirth
            height
            lastActive
            hubspotContactVid
            lastNoteDate
          }
          subscriptions(active: true){
            edges{
              node {
                id
                product {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  } 
}
`


export const UPSERT_SUBSCRIPTION_CHECK_MUTATION = gql`
mutation upsertSubscriptionCheckRecord($input: SubscriptionProcessChecksInput!){
	upsertSubscriptionCheckRecord(input: $input){
    error
    success
  }
}
`
